import { render, staticRenderFns } from "./mobileTable.vue?vue&type=template&id=90a29e96&scoped=true&"
import script from "./mobileTable.vue?vue&type=script&lang=js&"
export * from "./mobileTable.vue?vue&type=script&lang=js&"
import style0 from "./mobileTable.vue?vue&type=style&index=0&id=90a29e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a29e96",
  null
  
)

export default component.exports